const o = {
  ConfirmAndGoToNext: "louis/stepWizard/confirmAndGoToNext"
}, t = () => ({
  confirmAndGoToNext: () => {
    document.dispatchEvent(new CustomEvent(o.ConfirmAndGoToNext));
  }
});
export {
  o as StepWizardEvents,
  t as useStepWizard
};
//# sourceMappingURL=useStepWizard.js.map
